import React, { useEffect } from "react";
import { connect } from "react-redux";
import CalendarBox from "./CalendarBox.js";
import CalendarModal from "./CalendarModal.js";
import _ from "lodash";

function Calendar({}) {
	const calendarBoxes = Array.apply(null, Array(24)).map((item, index) => index);

	useEffect(() => {
	}, []);

	let shuffledBoxes = localStorage.getItem("shuffledBoxes");

	if (!shuffledBoxes) {
		shuffledBoxes = _.shuffle(calendarBoxes);
		localStorage.setItem("shuffledBoxes", JSON.stringify(shuffledBoxes));
	} else {
		shuffledBoxes = JSON.parse(shuffledBoxes);
	}
	return (
		<React.Fragment>
			<div className="flex justify-center">
				<div className="pt-20 text-white grid grid-cols-3 gap-8 sm:grid-cols-4 lg:grid-cols-6">
					{shuffledBoxes.map((box, index) => {
						return <CalendarBox key={box} index={box} />;
					})
					}
				</div>
			</div>
			<CalendarModal />
		</React.Fragment>
	);
}

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = dispatch => ({});

export default connect(
	mapStateToProps, mapDispatchToProps,
)(Calendar);